import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

import {
    getForumTopicById,
    incrementViews,
    incrementLikes,
    decrementLikes,
    incrementNbMessages,
    decrementNbMessages
} from "../../pages/forum/forumTopicService";

import {
    getAllForumReply,
    deleteForumReply,
    downloadFileFromForumReply
} from "../../services/forumReplyService";

import ForumReplyList from "./ForumReplyList";
import ForumReplyComposer from "./ForumReplyComposer";
import ForumTopicDetail from "./ForumTopicDetail";

import {
    isUserLoggedIn,
    getLoggedInUser
} from "../../pages/userapp/ServiceUserApp";

import { BASE_URL } from "../../utils/serverContextPath";

import "./ForumConversation.css";


//==============================================================
// ForumConversation
//==============================================================

export default function ForumConversation() {

    const { t } = useTranslation();

    //==========================================================
    // Format Date / Heure
    //==========================================================

    const formatDateTime = (dateValue) => {

        if (!dateValue) {
            return "";
        }

        //------------------------------------------------------
        // Format Spring Boot :
        // 14/07/2026 23:00:00
        //------------------------------------------------------

        if (typeof dateValue === "string") {

            const parts = dateValue.split(" ");

            if (parts.length === 2) {

                const datePart = parts[0].split("/");
                const timePart = parts[1].split(":");

                if (
                    datePart.length === 3 &&
                    timePart.length >= 2
                ) {

                    return `${datePart[0]}/${datePart[1]}/${datePart[2]} - ${timePart[0]}:${timePart[1]}`;

                }
            }
        }

        //------------------------------------------------------
        // ISO DATE
        //------------------------------------------------------

        return new Intl.DateTimeFormat(
            "fr-FR",
            {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            }
        ).format(new Date(dateValue));

    };


    //==========================================================
    // Utilisateur connecté
    //==========================================================

    const connected = isUserLoggedIn();

    //----------------------------------------------------------
    // Navigation
    //----------------------------------------------------------

    const navigate = useNavigate();
    const { id } = useParams();

    //----------------------------------------------------------
    // Utilisateur courant
    //----------------------------------------------------------

    const currentUser = getLoggedInUser();


    //==========================================================
    // Etats
    //==========================================================

    const [topic, setTopic] = useState(null);

    const [replies, setReplies] = useState([]);

    const [loading, setLoading] = useState(true);

    const [selectedReply, setSelectedReply] = useState(null);

    const [showComposer, setShowComposer] = useState(false);

    const [showDetail, setShowDetail] = useState(false);

    const [liked, setLiked] = useState(false);


    //==========================================================
    // ETATS PIECE JOINTE DU TOPIC
    //==========================================================

    const [topicAttachedFileUrl, setTopicAttachedFileUrl] =
        useState(null);

    const [topicAttachedFileType, setTopicAttachedFileType] =
        useState(null);

    const [loadingTopicAttachedFile, setLoadingTopicAttachedFile] =
        useState(false);

    const [topicAttachedFileError, setTopicAttachedFileError] =
        useState(false);


    //==========================================================
    // Auteur du sujet
    //==========================================================

    const author = topic?.author || {};


    //==========================================================
    // Avatar par défaut
    //==========================================================

    const defaultAvatar =
        "https://cdn-icons-png.flaticon.com/512/847/847969.png";


    //==========================================================
    // Photo de l'auteur
    //==========================================================

    const photo = author?.photoUrl
        ? `${BASE_URL}userapp/downloadprofile/${author.id}`
        : defaultAvatar;


    //==========================================================
    // Chargement du sujet
    //==========================================================

    const loadTopic = async () => {

        try {

            const response =
                await getForumTopicById(id);

            setTopic(response.data);

        }
        catch (error) {

            console.error(
                "Erreur chargement topic :",
                error
            );

        }

    };


    //==========================================================
    // Chargement des réponses
    //==========================================================

    const loadReplies = async () => {

        try {

            const response =
                await getAllForumReply(
                    "",
                    ["dateMessage"],
                    "ASC"
                );

            //--------------------------------------------------
            // Filtrage des réponses du sujet
            //--------------------------------------------------

            const list =
                response.data.filter(
                    item =>
                        item.forumTopic?.id === Number(id)
                );

            setReplies(list);

        }
        catch (error) {

            console.error(
                "Erreur chargement réponses :",
                error
            );

        }

    };


    //==========================================================
    // Chargement général
    //==========================================================

    const loadConversation = async () => {

        setLoading(true);

        await loadTopic();

        await loadReplies();

        setLoading(false);

    };


    //==========================================================
    // Initialisation
    //==========================================================

    useEffect(() => {

        loadConversation();

    }, [id]);


    //==========================================================
    // Incrémentation des vues
    //==========================================================

    useEffect(() => {

        if (id) {

            incrementViews(id)
                .catch(console.error);

        }

    }, [id]);


    //==========================================================
    // CHARGEMENT attachedFile1 DU TOPIC
    //==========================================================

    useEffect(() => {

        let objectUrl = null;


        const loadTopicAttachedFile = async () => {

            //--------------------------------------------------
            // Aucun topic
            //--------------------------------------------------

            if (!topic) {

                setTopicAttachedFileUrl(null);

                setTopicAttachedFileType(null);

                return;
            }


            //--------------------------------------------------
            // Aucun fichier attaché
            //--------------------------------------------------

            if (!topic.attachedFile1) {

                setTopicAttachedFileUrl(null);

                setTopicAttachedFileType(null);

                setTopicAttachedFileError(false);

                return;
            }


            try {

                setLoadingTopicAttachedFile(true);

                setTopicAttachedFileError(false);


                //------------------------------------------------
                // Endpoint du fichier attaché du TOPIC
                //
                // attachedFile1 = index 1
                //------------------------------------------------

                const url =
                    `${BASE_URL}forumtopic/downloadfile/${topic.id}/1`;


                console.log(
                    "Chargement pièce jointe Topic :",
                    url
                );


                //------------------------------------------------
                // Appel API en Blob
                //------------------------------------------------

                const response =
                    await axios.get(
                        url,
                        {
                            responseType: "blob"
                        }
                    );


                //------------------------------------------------
                // Type MIME
                //------------------------------------------------

                const contentType =
                    response.headers?.["content-type"] ||
                    response.data?.type ||
                    "";


                console.log(
                    "Content-Type fichier Topic :",
                    contentType
                );


                //------------------------------------------------
                // Création Blob
                //------------------------------------------------

                const blob =
                    new Blob(
                        [response.data],
                        {
                            type: contentType
                        }
                    );


                //------------------------------------------------
                // Création URL temporaire
                //------------------------------------------------

                objectUrl =
                    window.URL.createObjectURL(blob);


                setTopicAttachedFileUrl(
                    objectUrl
                );


                //------------------------------------------------
                // Détermination du type
                //------------------------------------------------

                if (
                    contentType.toLowerCase()
                        .startsWith("image/")
                ) {

                    setTopicAttachedFileType(
                        "image"
                    );

                }
                else if (
                    contentType.toLowerCase()
                        .startsWith("video/")
                ) {

                    setTopicAttachedFileType(
                        "video"
                    );

                }
                else {

                    setTopicAttachedFileType(
                        "other"
                    );

                }

            }
            catch (error) {

                console.error(
                    "Erreur lors du chargement de attachedFile1 du topic :",
                    error
                );


                setTopicAttachedFileUrl(null);

                setTopicAttachedFileType(null);

                setTopicAttachedFileError(true);

            }
            finally {

                setLoadingTopicAttachedFile(false);

            }

        };


        loadTopicAttachedFile();


        //======================================================
        // Nettoyage ObjectURL
        //======================================================

        return () => {

            if (objectUrl) {

                window.URL.revokeObjectURL(
                    objectUrl
                );

            }

        };

    }, [
        topic?.id,
        topic?.attachedFile1
    ]);


    //==========================================================
    // Ouvrir fichier attaché
    //==========================================================

    const openTopicAttachedFile = () => {

        if (!topicAttachedFileUrl) {
            return;
        }

        window.open(
            topicAttachedFileUrl,
            "_blank",
            "noopener,noreferrer"
        );

    };


    //==========================================================
    // Affichage pièce jointe Topic
    //==========================================================

    const renderTopicAttachedFile = () => {

        //------------------------------------------------------
        // Aucun fichier
        //------------------------------------------------------

        if (!topic?.attachedFile1) {
            return null;
        }


        //------------------------------------------------------
        // Chargement
        //------------------------------------------------------

        if (loadingTopicAttachedFile) {

            return (

                <div
                    className="text-center py-4"
                >

                    <div
                        className="spinner-border text-success"
                        role="status"
                    >

                        <span
                            className="visually-hidden"
                        >
                            Chargement...
                        </span>

                    </div>

                    <div
                        className="small text-muted mt-2"
                    >
                        Chargement du fichier...
                    </div>

                </div>

            );

        }


        //------------------------------------------------------
        // Erreur
        //------------------------------------------------------

        if (topicAttachedFileError) {

            return (

                <div
                    className="alert alert-warning mt-3"
                >

                    <i
                        className="bi bi-exclamation-triangle me-2"
                    ></i>

                    Impossible d'afficher
                    le fichier attaché.

                </div>

            );

        }


        //------------------------------------------------------
        // URL inexistante
        //------------------------------------------------------

        if (!topicAttachedFileUrl) {
            return null;
        }


        //======================================================
        // IMAGE
        //======================================================

        if (topicAttachedFileType === "image") {

            return (

                <div
                    className="forum-topic-attached-file mt-4"
                    style={{
                        width: "100%",
                        backgroundColor: "#000",
                        borderRadius: "8px",
                        overflow: "hidden",
                        textAlign: "center"
                    }}
                >

                    <img
                        src={topicAttachedFileUrl}
                        alt={
                            topic?.topicObject ||
                            "Image attachée"
                        }
                        onClick={
                            openTopicAttachedFile
                        }
                        style={{
                            display: "block",
                            width: "100%",
                            maxHeight: "600px",
                            objectFit: "contain",
                            cursor: "pointer",
                            backgroundColor: "#000"
                        }}
                    />

                </div>

            );

        }


        //======================================================
        // VIDEO
        //======================================================

        if (topicAttachedFileType === "video") {

            return (

                <div
                    className="forum-topic-attached-file mt-4"
                    style={{
                        width: "100%",
                        backgroundColor: "#000",
                        borderRadius: "8px",
                        overflow: "hidden"
                    }}
                >

                    <video
                        src={topicAttachedFileUrl}
                        controls
                        preload="metadata"
                        playsInline
                        style={{
                            display: "block",
                            width: "100%",
                            maxHeight: "600px",
                            backgroundColor: "#000"
                        }}
                    >

                        Votre navigateur
                        ne supporte pas
                        la lecture vidéo.

                    </video>

                </div>

            );

        }


        //======================================================
        // AUTRE TYPE DE FICHIER
        //======================================================

        return (

            <div
                className="mt-4"
            >

                <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={
                        openTopicAttachedFile
                    }
                >

                    <i
                        className="bi bi-paperclip me-2"
                    ></i>

                    Fichier attaché

                </button>

            </div>

        );

    };


    //==========================================================
    // Nouvelle réponse
    //==========================================================

    const handleAddReply = () => {

        setSelectedReply(null);

        setShowComposer(true);

    };


    //==========================================================
    // Modification d'une réponse
    //==========================================================

    const handleEditReply = (reply) => {

        setSelectedReply(reply);

        setShowComposer(true);

    };


    //==========================================================
    // Enregistrement terminé
    //==========================================================

    const handleReplySaved = async () => {

        setShowComposer(false);

        await incrementNbMessages(id);

        await loadConversation();

    };


    //==========================================================
    // Suppression
    //==========================================================

    const handleDeleteReply = async (replyId) => {

        if (
            !window.confirm(
                "Supprimer cette réponse ?"
            )
        ) {

            return;
        }


        try {

            await deleteForumReply(
                replyId
            );

            await decrementNbMessages(
                id
            );

            await loadConversation();

        }
        catch (error) {

            console.error(
                error
            );

            alert(
                "Erreur lors de la suppression."
            );

        }

    };


    //==========================================================
    // Like
    //==========================================================

    const handleLike = async () => {

        try {

            await incrementLikes(id);

            setLiked(true);

            await loadTopic();

        }
        catch (error) {

            console.error(
                error
            );

        }

    };


    //==========================================================
    // Retirer Like
    //==========================================================

    const handleUnlike = async () => {

        try {

            await decrementLikes(id);

            setLiked(false);

            await loadTopic();

        }
        catch (error) {

            console.error(
                error
            );

        }

    };


    //==========================================================
    // Téléchargement d'une pièce jointe d'une REPONSE
    //==========================================================

    const handleDownload = async (
        replyId,
        index
    ) => {

        try {

            const response =
                await downloadFileFromForumReply(
                    replyId,
                    index
                );


            const blob =
                new Blob(
                    [response.data]
                );


            const url =
                window.URL.createObjectURL(
                    blob
                );


            const link =
                document.createElement(
                    "a"
                );


            link.href = url;

            link.download =
                "piece_jointe";


            document.body.appendChild(
                link
            );


            link.click();

            link.remove();


            window.URL.revokeObjectURL(
                url
            );

        }
        catch (error) {

            console.error(
                error
            );

        }

    };


    //==========================================================
    // Rafraîchir conversation
    //==========================================================

    const refreshConversation = async () => {

        await loadConversation();

    };


    //==========================================================
    // Retour Forum
    //==========================================================

    const handleBack = () => {

        navigate(
            "/forum"
        );

    };


    //==========================================================
    // Détail du sujet
    //==========================================================

    const handleTopicDetail = () => {

        setShowDetail(
            true
        );

    };


    //==========================================================
    // Fermer détail
    //==========================================================

    const handleCloseDetail = () => {

        setShowDetail(
            false
        );

    };


    //==========================================================
    // Chargement
    //==========================================================

    if (loading) {

        return (

            <div
                className="container py-5 text-center"
            >

                <div
                    className="spinner-border text-success"
                    role="status"
                >

                    <span
                        className="visually-hidden"
                    >
                        Chargement...
                    </span>

                </div>

                <h4
                    className="mt-4"
                >
                    Chargement de la discussion...
                </h4>

            </div>

        );

    }


    //==========================================================
    // Topic introuvable
    //==========================================================

    if (!topic) {

        return (

            <div
                className="container py-5 text-center"
            >

                <i
                    className="bi bi-exclamation-triangle display-1 text-warning"
                ></i>

                <h3
                    className="mt-4"
                >
                    Sujet introuvable
                </h3>

                <button
                    className="btn btn-success mt-3"
                    onClick={handleBack}
                >

                    <i
                        className="bi bi-arrow-left me-2"
                    ></i>

                    {t("button.back")} au Forum

                </button>

            </div>

        );

    }


    //==========================================================
    // RENDER
    //==========================================================

    return (

        <div
            className="container-fluid forum-conversation"
        >

            {/*====================================================
                Header
            ====================================================*/}

            <div
                className="forum-sticky-header"
            >

                <div
                    className="forum-sticky-content"
                >

                    <div
                        className="forum-sticky-left"
                    >

                        <button
                            className="btn btn-outline-light"
                            onClick={
                                handleBack
                            }
                        >

                            <i
                                className="bi bi-arrow-left-circle me-2"
                            ></i>

                            {t("button.back")}

                        </button>


                        <button
                            className="btn btn-light"
                            onClick={
                                handleTopicDetail
                            }
                        >

                            <i
                                className="bi bi-info-circle me-2"
                            ></i>

                            {t("forum.detail")}

                        </button>

                    </div>


                    {
                        connected && (

                            <button
                                className="btn btn-warning"
                                onClick={
                                    handleAddReply
                                }
                            >

                                {t("forum.reply")}

                            </button>

                        )
                    }

                </div>

            </div>


            {/*====================================================
                Sujet
            ====================================================*/}

            <div
                className="card shadow-sm mb-4"
            >

                <div
                    className="card-body"
                >

                    <div
                        className="d-flex justify-content-between"
                    >

                        <div>

                            <h2
                                className="text-success fw-bold"
                            >

                                {topic.topicObject}

                            </h2>


                            <div
                                className="d-flex align-items-center mt-3"
                            >

                                <img
                                    src={photo}
                                    alt={
                                        author?.fullName ||
                                        "Auteur"
                                    }
                                    className="rounded-circle shadow-sm me-3"
                                    style={{
                                        width: "60px",
                                        height: "60px",
                                        objectFit: "cover"
                                    }}
                                    onError={(e) => {

                                        e.currentTarget.src =
                                            defaultAvatar;

                                    }}
                                />


                                <div>

                                    <div
                                        className="fw-bold"
                                    >

                                        {
                                            author?.fullName ||
                                            "-"
                                        }

                                    </div>


                                    <small
                                        className="text-muted"
                                    >

                                        {
                                            formatDateTime(
                                                topic.dateForumTopic
                                            )
                                        }

                                    </small>

                                </div>

                            </div>

                        </div>


                        <div>

                            {
                                topic.pinned &&

                                <span
                                    className="badge bg-warning text-dark me-2"
                                >

                                    <i
                                        className="bi bi-pin-angle-fill me-1"
                                    ></i>

                                    Epinglé

                                </span>
                            }


                            {
                                topic.resolved &&

                                <span
                                    className="badge bg-success"
                                >

                                    <i
                                        className="bi bi-check-circle-fill me-1"
                                    ></i>

                                    Résolu

                                </span>
                            }

                        </div>

                    </div>


                    <hr />


                    {/*================================================
                        Corps du sujet
                    =================================================*/}

                    <div
                        className="forum-topic-body"
                    >

                        {topic.topicBody}

                    </div>


                    {/*================================================
                        ATTACHED FILE 1
                    =================================================*/}

                    {
                        renderTopicAttachedFile()
                    }


                    <hr />


                    {/*================================================
                        Statistiques
                    =================================================*/}

                    <div
                        className="row text-center"
                    >

                        <div
                            className="col-md-3"
                        >

                            <h3
                                className="text-primary"
                            >

                                {
                                    topic.nbViews || 0
                                }

                            </h3>

                            <small>

                                {t("forum.views")}

                            </small>

                        </div>


                        <div
                            className="col-md-3"
                        >

                            <h3
                                className="text-danger"
                            >

                                {
                                    topic.nbLikes || 0
                                }

                            </h3>

                            <small>

                                {t("forum.likes")}

                            </small>

                        </div>


                        <div
                            className="col-md-3"
                        >

                            <h3
                                className="text-success"
                            >

                                {
                                    topic.nbMessage ||
                                    replies.length
                                }

                            </h3>

                            <small>

                                {t("forum.replies")}

                            </small>

                        </div>


                        <div
                            className="col-md-3"
                        >

                            {
                                !liked ?

                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={
                                            handleLike
                                        }
                                    >

                                        <i
                                            className="bi bi-hand-thumbs-up me-2"
                                        ></i>

                                        {t("forum.likes")}

                                    </button>

                                    :

                                    <button
                                        className="btn btn-primary"
                                        onClick={
                                            handleUnlike
                                        }
                                    >

                                        <i
                                            className="bi bi-hand-thumbs-up-fill me-2"
                                        ></i>

                                        Aimé

                                    </button>
                            }

                        </div>

                    </div>

                </div>

            </div>


            {/*====================================================
                Utilisateur non connecté
            ====================================================*/}

            {
                !connected && (

                    <div
                        className="alert alert-info"
                    >

                        <i
                            className="bi bi-lock-fill me-2"
                        ></i>

                        Vous devez être connecté
                        pour participer à cette discussion.

                    </div>

                )
            }


            {/*====================================================
                Liste des réponses
            ====================================================*/}

            <ForumReplyList

                replies={replies}

                loading={loading}

                currentUser={currentUser}

                onEdit={handleEditReply}

                onDelete={handleDeleteReply}

                onLike={handleLike}

                onDownloadFile={
                    handleDownload
                }

            />


            {/*====================================================
                Composer Réponse
            ====================================================*/}

            {
                showComposer &&

                <ForumReplyComposer

                    topic={topic}

                    reply={selectedReply}

                    onClose={() => {

                        setShowComposer(
                            false
                        );

                        setSelectedReply(
                            null
                        );

                    }}

                    onSaved={
                        handleReplySaved
                    }

                />

            }


            {/*====================================================
                Détail du sujet
            ====================================================*/}

            {
                showDetail &&

                <ForumTopicDetail

                    topic={topic}

                    onClose={
                        handleCloseDetail
                    }

                />

            }

        </div>

    );

}